import React, { useMemo } from 'react';
import styled from 'styled-components';
import { EventConditionInfo } from '../../components';
import {
  IEventConditionFieldsFragment,
  PathDirectionKey,
} from '../../../../utils/apollo/graphqlSchema';
import * as BuilderInfoUI from '../../BuilderInfoUI';

interface IProps {
  directionKey: PathDirectionKey;
  startConditions: IEventConditionFieldsFragment[];
  endConditions: IEventConditionFieldsFragment[];
}

const DirectionContainer = styled(BuilderInfoUI.PlainInfo)`
  margin-top: 4px;
`;

export default ({ directionKey, startConditions, endConditions }: IProps) => {
  const isPathDirectionKeyForward = directionKey === PathDirectionKey.Forward;

  const directionLabel = isPathDirectionKeyForward ? 'Forward' : 'Backward';

  const conditions = useMemo(() => {
    const result = [
      <BuilderInfoUI.VerticalNestedRow key="start-conditions">
        {startConditions.map((eventCondition, eventIndex) => (
          <EventConditionInfo
            key={`path-builder-event-start-${eventIndex}`}
            label={'Starting Event(s)'}
            condition={eventCondition}
            noMarginBottom={true}
          />
        ))}
      </BuilderInfoUI.VerticalNestedRow>,
      <BuilderInfoUI.VerticalNestedRow key="end-conditions">
        {endConditions.map((eventCondition, eventIndex) => (
          <EventConditionInfo
            key={`path-builder-event-end-${eventIndex}`}
            label={'Ending Event(s)'}
            condition={eventCondition}
            noMarginBottom={true}
          />
        ))}
      </BuilderInfoUI.VerticalNestedRow>,
    ];

    if (!isPathDirectionKeyForward) {
      result.reverse();
    }

    return result;
  }, [isPathDirectionKeyForward, endConditions, startConditions]);

  return (
    <BuilderInfoUI.GridColumns>
      <DirectionContainer>
        <BuilderInfoUI.InfoLabel>Direction</BuilderInfoUI.InfoLabel>
        <BuilderInfoUI.PlainValue>{directionLabel}</BuilderInfoUI.PlainValue>
      </DirectionContainer>
      <BuilderInfoUI.VerticalRow>{conditions}</BuilderInfoUI.VerticalRow>
    </BuilderInfoUI.GridColumns>
  );
};
